import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Student } from '../models/student';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WizardService {
  env = environment;

  constructor(
    private router: Router,
    private snackbar: MatSnackBar
  ) { }

  // Modal
  close_result!: string;
  public current_router_path: string = '';

  validateid_number(id_number: number): boolean {

    if (id_number.toString().length == 13) {
      return true;
    }
    return false;
  }

  verifyid_number(control: AbstractControl) {

    if (!control.value) {
      return { id_number: true };
    }

    if (!control.value.match(/^\d{13}$/)) {
      return { id_number: true };
    }

    const numArray = control.value.split('').map(Number);

    let errors = false;

    // Validate the day and month
    const idMonth = parseInt(`${numArray[2]}${numArray[3]}`, 10);
    const idDay = parseInt(`${numArray[4]}${numArray[5]}`, 10);

    if (idMonth < 1 || idMonth > 12 || idDay < 1 || idDay > 31) {
      errors = true;
    }

    // Validate citizenship
    // Allows SA citizens and permanent residents
    const idCitizenship = numArray[10];
    if (idCitizenship !== 0 && idCitizenship !== 1) {
      errors = true;
    }

    // Check Digit Verification
    const evenDigits: number[] = [];
    const oddDigits: number[] = [];
    // Loop through modified numArray, storing the keys and their values in the above arrays
    numArray.forEach((digit: number, index: number) => {
      if (index === 0 || index % 2 === 0) {
        oddDigits.push(digit);
      } else {
        evenDigits.push(digit);
      }
    });

    // use array pop method to remove the last digit from odd_digits and store it in checkDigit
    const checkDigit = oddDigits.pop();

    // All digits in odd positions (excluding the check digit) must be added together.
    const addedOdds = oddDigits.reduce((sum, digit) => sum + digit, 0);

    // All digits in even positions must be concatenated to form a 6 digit number.
    const concatenatedEvens = parseInt(evenDigits.join(''), 10);

    // This 6 digit number must then be multiplied by 2.
    const evensx2 = concatenatedEvens * 2;

    // Add all the numbers produced from the even numbers x 2
    const addedEvens = `${evensx2}`.split('').reduce((sum, digit) => sum + parseInt(digit, 10), 0);

    const sum = addedOdds + addedEvens;

    // get the last digit of the sum
    const lastDigit = parseInt(`${sum}`.slice(-1), 10);

    // calculate verify check digit
    const verifyCheckDigit = (10 - lastDigit) % 10;

    if (errors) {
      return { id_number: true }
    }

    if (verifyCheckDigit === checkDigit) {
      return null;
    }
    else {
      return { id_number: true }
    }
  }

  navigateTo(route: string): void {
    this.router.navigate([route]);
    this.current_router_path = route;
  }


}
